import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'

export default function SalesQuoteDetailsComponent({
  handleInnerFormChange, getSalesQuoteStatusName,
  salesQuotePriority, selectedSalesQuoteNumber, selectedSalesQuote, sQCreateSelectOption,
  opportunities, contacts, customers, generateSalesQuoteNumber, employee, organizationUnits,
  priceBooks, termslibraries, salesQuoteFrequency, tagNames
}: any) {
  console.log(selectedSalesQuote, 'sQCreateSelectOption')
  return (
    <>
      <AccordionContainer
        child={
          <div className=''>
            <div className=' pb-3'>
              <InputLabelContainer label="SalesQuote Number" />
              <InputLabelContainer label={selectedSalesQuoteNumber?.SalesQuoteNumber} />
              <button
                className=" bg-blue-700 text-white rounded font-medium px-2 py-2 "
                onClick={generateSalesQuoteNumber}
                type="submit"
              >
                Generate Sales Quote Number
              </button>
            </div>
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
                label="Sales Quote from"
                labelField="Text"
                list={sQCreateSelectOption}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'SQCreateSelectOptionId'
                  );
                }}
                optionName='Choose Sales Quote'
                type="select"
                value={selectedSalesQuote?.SQCreateSelectOptionId}
                valueField="Value"
              />
              {selectedSalesQuote?.SQCreateSelectOptionId == 10 && (
                <InputContainer
                  label="Contact Name"
                  labelField="FirstName"
                  list={contacts}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'ContactId'
                    );
                  }}
                  optionName='Choose Contact Name'
                  type="select"
                  value={selectedSalesQuote?.ContactId}
                  valueField="Id"
                />

              )}
              {selectedSalesQuote?.SQCreateSelectOptionId === 20 && (
                <InputContainer
                  label="Customer Name"
                  labelField="CustomerName"
                  list={customers}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'CustomerId'
                    );
                  }}
                  optionName='Choose Customer Name'
                  type="select"
                  value={selectedSalesQuote?.CustomerId}
                  valueField="Id"
                />

              )}
              {selectedSalesQuote?.SQCreateSelectOptionId === 30 && (
                <InputContainer
                  label="Opportunity Name"
                  labelField="Name"
                  list={opportunities}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'OpportunityId'
                    );
                  }}
                  optionName='Choose Opportunity Name'
                  type="select"
                  value={selectedSalesQuote?.OpportunityId}
                  valueField="Id"
                />
              )}
            </div>

            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4 pt-4'>
              <InputContainer
                label="Percentage Of Possibilities"
                name="PercentageOfPossisibilities"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'PercentageOfPossisibilities'
                  )
                }}
                type="text"
                value={selectedSalesQuote?.PercentageOfPossisibilities}
              />
              <InputContainer
                label="SalesPerson"
                labelField="FirstName"
                list={employee}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'SalesPersonId'
                  );
                }}
                optionName='Choose Sales Person'
                type="select"
                value={selectedSalesQuote?.SalesPersonId}
                valueField="Id"
              />
              <InputContainer
                label="Organization Unit"
                labelField="OrganizationUnitInfo.Name"
                list={organizationUnits}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'OrganizationUnitId'
                  );
                }}
                optionName='Choose Organization Unit'
                type="select"
                value={selectedSalesQuote?.OrganizationUnitId}
                valueField="OrganizationUnitInfo.Id"
              />
              <InputContainer
                label="Price Book"
                labelField="Name"
                list={priceBooks}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'PriceBookId'
                  );
                }}
                optionName='Choose Price Book'
                type="select"
                value={selectedSalesQuote?.PriceBookId}
                valueField="Id"
              />
              <InputContainer
                label="Term Library"
                labelField="Name"
                list={termslibraries}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'TermLibraryId'
                  );
                }}
                optionName='Choose Term Library'
                type="select"
                value={selectedSalesQuote?.TermLibraryId}
                valueField="Id"
              />

              <InputContainer
                label="SalesQuote Date"
                name="SalesQuoteDateOnUtc"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'SalesQuoteDateOnUtc'
                  )
                }}
                type="date"
                value={selectedSalesQuote?.SalesQuoteDateOnUtc}
              />
              <InputContainer
                label="ValidUptoDate"
                name="ValidUptoDateOnUtc"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'ValidUptoDateOnUtc'
                  )
                }}
                type="date"
                value={selectedSalesQuote?.ValidUptoDateOnUtc}
              />
              <InputContainer
                label="DeliveryTimePeriod"
                name="DeliveryTimePeriod"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DeliveryTimePeriod'
                  )
                }}
                type="text"
                value={selectedSalesQuote?.DeliveryTimePeriod}
              />
              <InputContainer
                label="SalesQuoteRequirement FrequencyType"
                labelField="Text"
                list={salesQuoteFrequency}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'SalesQuoteRequirementFrequencyTypeId'
                  )
                }}
                optionName='Choose Frequency Type'
                type="select"
                value={selectedSalesQuote?.SalesQuoteRequirementFrequencyTypeId}
                valueField="Value"
              />

              <InputContainer
                label="SalesQuotePriority"
                labelField="Text"
                list={salesQuotePriority}
                onValueChange={(event: any, newValue: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'SalesQuotePriorityId'
                  );
                }}
                optionName='Choose SalesQuotePriority'
                type="select"
                value={selectedSalesQuote?.SalesQuotePriorityId}
                valueField="Value"
              />
              <InputContainer
                label="Transportation Charges"
                name="TransportationCharges"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'TransportationCharges'
                  )
                }}
                type="number"
                value={selectedSalesQuote?.TransportationCharges}
              />
              <InputContainer
                label="DiscountAmount"
                name="DiscountAmount"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'DiscountAmount'
                  )
                }}
                type="number"
                value={selectedSalesQuote?.DiscountAmount}
              />
              <InputContainer
                label="Remarks"
                name="Remarks"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Remarks'
                  )
                }}
                type="text"
                value={selectedSalesQuote?.Remarks}
              />

              {selectedSalesQuote?.Id
                ? <div>
                  <InputLabelContainer label="SalesQuote Status" />
                  <InputLabelContainer label={getSalesQuoteStatusName(selectedSalesQuote?.SalesQuoteStatusId)} />
                </div>
                : null}
            </div>
          </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Tag"
              labelField="displayText"
              list={tagNames}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TagEntityMappingsValueIds',
                );
              }}
              optionName='Choose Sales Quote Tag'
              type="select"
              value={selectedSalesQuote?.TagEntityMappingsValueIds}
              valueField="ValueId"
            />
          </div>
        }
        expandedPanel="Tag"
        headerTitle="Sales Quote Tag"
      />
    </>
  )
}